class IPC {
  subscribe (channel, listener) {
  }

  send (channel, ...args) {
  }

  sendToHost (channel, ...args) {
  }

  sendSync (channel, ...args) {
  }

  invoke (channel, ...args) {
  }
}

module.exports = new IPC();
